import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import {
  Grid, Button, CardContent,
  TextField, Typography, MenuItem
} from '@material-ui/core'

import States from '../states.json'

import { updateOrgUnitInfo } from '../../../../redux/actions'

import { NotificationToast } from '../../tools/Toast'
import { handleTextPrepper } from '../../../../utils'

/**
 * Returns org unit mgmt edit form
 */
const OrgUnitMgmtEditUnit = (props) => {
  const {
    onTabSwap, onSaveBackTrack, unitName, unitDesc, address, address2,
    city, state, postalCode, selectedKey, classes, textClasses
  } = props

  const [form, setForm] = useState({
    unitName,
    unitDesc,
    address,
    address2,
    city,
    state,
    postalCode
  })

  const dispatch = useDispatch()

  const submitForm = async () => {
    const unitID = selectedKey
    const info = {
      unitName: handleTextPrepper(form.unitName),
      unitDesc: handleTextPrepper(form.unitDesc),
      address: handleTextPrepper(form.address),
      address2: handleTextPrepper(form.address2),
      city: handleTextPrepper(form.city),
      state: handleTextPrepper(form.state),
      postalCode: handleTextPrepper(form.postalCode)
    }
    dispatch(updateOrgUnitInfo(info, unitID, fireSuccess, fireFailure))
    onSaveBackTrack()
  }

  const fireSuccess = () => {
    NotificationToast(false, 'Unit updated successfully!')
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to update unit.')
  }

  const onChange = (prop) => e => {
    setForm({ ...form, [prop]: e.target.value })
  }

  const getStateOptions = () => {
    const items = []
    for (const [key, value] of Object.entries(States)) {
      items.push(<MenuItem id={key} key={key} value={key}>{value}</MenuItem>)
    }
    return items
  }

  const changesMade = form.unitName !== unitName || form.unitDesc !== unitDesc || form.address !== address ||
    form.address2 !== address2 || form.city !== city || form.postalCode !== postalCode || form.state !== state

  return (
    <CardContent className='mt-2 ml-1'>
      <Grid item container direction='row' className='ml-1 mt-2'>
        <Button className={classes.greenBtn} variant='contained' onClick={(e) => { e.preventDefault(); onTabSwap('unit', changesMade) }}>Back</Button>
      </Grid>
      <Grid item container direction='row' className='my-3 ml-1'>
        <Grid item container direction='column' sm={6}>
          {/* <h4 className='unselectable'>Create New Unit</h4> */}
          <Typography variant='h4' color='primary' className='font-weight-bold' classes={{ colorPrimary: classes.greyColor }}>Edit Unit</Typography>
        </Grid>
      </Grid>
      <Grid item container direction='row' className='ml-1'>
        <Grid item container direction='column' sm={12}>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={5} className='mr-2'>
              <h5>Unit Name</h5>
              <TextField
                value={form.unitName}
                onChange={onChange('unitName')}
                placeholder='Unit Name'
                name='unitName'
                id='unitName'
                error={form.unitName.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>

            <Grid item container direction='column' sm={6}>
              <h5>Unit Description</h5>
              <TextField
                value={form.unitDesc}
                onChange={onChange('unitDesc')}
                placeholder='Unit Description'
                name='unitDesc'
                id='unitDesc'
                error={form.unitDesc.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              // multiline
              // rows='2'
              />
            </Grid>
          </Grid>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={5} className='mr-2'>
              <h5>Address</h5>
              <TextField
                value={form.address}
                onChange={onChange('address')}
                placeholder='Address'
                name='address'
                id='address'
                error={form.address.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>

            <Grid item container direction='column' sm={6}>
              <h5>Address 2</h5>
              <TextField
                value={form.address2}
                onChange={onChange('address2')}
                placeholder='Address 2'
                name='address2'
                id='address2'
                // error={form.address2.length === 0}
                // required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>
          </Grid>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={4} className='mr-2'>
              <h5>City</h5>
              <TextField
                value={form.city}
                onChange={onChange('city')}
                placeholder='City'
                name='city'
                id='city'
                error={form.city.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>
            <Grid item container direction='column' sm={4} className='mr-2'>
              <h5>State</h5>
              <TextField
                value={form.state}
                onChange={onChange('state')}
                placeholder='State'
                name='state'
                id='state'
                error={form.state.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
                select
              >
                {getStateOptions()}
              </TextField>
            </Grid>
            <Grid item container direction='column' sm={3}>
              <h5>Zip</h5>
              <TextField
                value={form.postalCode}
                onChange={onChange('postalCode')}
                placeholder='Zip Code'
                name='postalCode'
                id='postalCode'
                error={form.postalCode.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item container direction='row' className='justify-content-end mt-5 mb-3 mr-1'>
          <Button
            className={classes.saveBtn}
            variant='contained'
            disabled={!changesMade}
            onClick={(e) => { e.preventDefault(); submitForm(form) }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </CardContent>
  )
}

export default OrgUnitMgmtEditUnit
